import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import badgeTranslateEN from './locales/badge/badgeTranslateEN';
import badgeTranslatePTBR from './locales/badge/badgeTranslatePTBR';
import birthTranslateEN from './locales/birth/birthTranslateEN';
import birthTranslatePTBR from './locales/birth/birthTranslatePTBR';
import billingTranslateEN from './locales/billing/billingTranslateEN';
import billingTranslatePTBR from './locales/billing/billingTranslatePTBR';
import catalogTranslateEN from './locales/catalog/catalogTranslateEN';
import catalogTranslatePTBR from './locales/catalog/catalogTranslatePTBR';
import clientPortalTranslateEN from './locales/clientPortal/clientPortalTranslateEN';
import clientPortalTranslatePTBR from './locales/clientPortal/clientPortalTranslatePTBR';
import contractTranslateEN from './locales/contract/contractTranslateEN';
import contractTranslatePTBR from './locales/contract/contractTranslatePTBR';
import dashboardTranslateEN from './locales/dashboard/dashboardTranslateEN';
import dashboardTranslatePTBR from './locales/dashboard/dashboardTranslatePTBR';
import errorsTranslateEN from './locales/errors/errorsTranslateEN';
import errorsTranslatePTBR from './locales/errors/errorsTranslatePTBR';
import eventTranslateEN from './locales/event/eventTranslateEN';
import eventTranslatePTBR from './locales/event/eventTranslatePTBR';
import fileDropZoneTranslateEN from './locales/fileDropZone/fileDropZoneEN';
import fileDropZoneTranslatePTBR from './locales/fileDropZone/fileDropZonePTBR';
import galleryTranslateEN from './locales/gallery/galleryTranslateEN';
import galleryTranslatePTBR from './locales/gallery/galleryTranslatePTBR';
import landingTranslateEN from './locales/landing/landingTranslateEN';
import landingTranslatePTBR from './locales/landing/landingTranslatePTBR';
import leadTranslateEN from './locales/lead/leadTranslateEN';
import leadTranslatePTBR from './locales/lead/leadTranslatePTBR';
import locationTranslateEN from './locales/location/locationTranslateEN';
import locationTranslatePTBR from './locales/location/locationTranslatePTBR';
import loginTranslateEN from './locales/login/loginTranslateEN';
import loginTranslatePTBR from './locales/login/loginTranslatePTBR';
import publicPagesTranslateEN from './locales/publicPages/publicPagesTranslateEN';
import publicPagesTranslatePTBR from './locales/publicPages/publicPagesTranslatePTBR';
import referrerTranslateEN from './locales/referrer/referrerTranslateEN';
import referrerTranslatePTBR from './locales/referrer/referrerTranslatePTBR';
import registerTranslateEN from './locales/register/registerTranslateEN';
import registerTranslatePTBR from './locales/register/registerTranslatePTBR';
import reportsTranslateEN from './locales/reports/reportsTranslateEN';
import reportsTranslatePTBR from './locales/reports/reportsTranslatePTBR';
import roleTranslateEN from './locales/role/roleTranslateEN';
import roleTranslatePTBR from './locales/role/roleTranslatePTBR';
import saleTranslateEN from './locales/sale/saleTranslateEN';
import saleTranslatePTBR from './locales/sale/saleTranslatePTBR';
import settingsTranslateEN from './locales/settings/settingsTranslateEN';
import settingsTranslatePTBR from './locales/settings/settingsTranslatePTBR';
import statisticsTranslateEN from './locales/statistics/statisticsTranslateEN';
import statisticsTranslatePTBR from './locales/statistics/statisticsTranslatePTBR';
import sidenavbarTranslateEN from './locales/sidenavbar/sidenavbarTranslateEN';
import sidenavbarTranslatePTBR from './locales/sidenavbar/sidenavbarTranslatePTBR';
import teamTranslateEN from './locales/team/teamTranslateEN';
import teamTranslatePTBR from './locales/team/teamTranslatePTBR';
import tenantTranslateEN from './locales/tenant/tenantTranslateEN';
import TenantTranslatePTBR from './locales/tenant/tenantTranslatePTBR';
import todoTranslateEN from './locales/todo/todoTranslateEN';
import todoTranslatePTBR from './locales/todo/todoTranslatePTBR';

const resources = {
  en: {
    translation: {
      appName: 'Clicker Sphere',
      poweredBy: 'Powered by Clicker Sphere',
      login: loginTranslateEN,
      register: registerTranslateEN,
      roles: roleTranslateEN,
      sidenavbar: sidenavbarTranslateEN,
      lead: leadTranslateEN,
      event: eventTranslateEN,
      tenant: tenantTranslateEN,
      todo: todoTranslateEN,
      errors: errorsTranslateEN,
      catalog: catalogTranslateEN,
      contract: contractTranslateEN,
      clientPortal: clientPortalTranslateEN,
      sale: saleTranslateEN,
      landing: landingTranslateEN,
      settings: settingsTranslateEN,
      dashboard: dashboardTranslateEN,
      badge: badgeTranslateEN,
      billing: billingTranslateEN,
      team: teamTranslateEN,
      reports: reportsTranslateEN,
      fileDropZone: fileDropZoneTranslateEN,
      statistics: statisticsTranslateEN,
      gallery: galleryTranslateEN,
      publicPages: publicPagesTranslateEN,
      location: locationTranslateEN,
      birth: birthTranslateEN,
      referrer: referrerTranslateEN,
    },
  },
  'pt-BR': {
    translation: {
      appName: 'Clicker Sphere',
      poweredBy: 'Feito com Clicker Sphere',
      login: loginTranslatePTBR,
      register: registerTranslatePTBR,
      roles: roleTranslatePTBR,
      sidenavbar: sidenavbarTranslatePTBR,
      lead: leadTranslatePTBR,
      event: eventTranslatePTBR,
      tenant: TenantTranslatePTBR,
      todo: todoTranslatePTBR,
      errors: errorsTranslatePTBR,
      catalog: catalogTranslatePTBR,
      contract: contractTranslatePTBR,
      clientPortal: clientPortalTranslatePTBR,
      sale: saleTranslatePTBR,
      landing: landingTranslatePTBR,
      settings: settingsTranslatePTBR,
      dashboard: dashboardTranslatePTBR,
      badge: badgeTranslatePTBR,
      billing: billingTranslatePTBR,
      team: teamTranslatePTBR,
      reports: reportsTranslatePTBR,
      fileDropZone: fileDropZoneTranslatePTBR,
      statistics: statisticsTranslatePTBR,
      gallery: galleryTranslatePTBR,
      publicPages: publicPagesTranslatePTBR,
      location: locationTranslatePTBR,
      birth: birthTranslatePTBR,
      referrer: referrerTranslatePTBR,
    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    defaultNS: 'translation',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
